
import moment from "moment";
import "moment/locale/fa";
import { useEffect, useState } from "react";
import { Button, Dropdown, Modal } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import toast from "react-hot-toast";

import { useNavigate, useParams } from "react-router-dom";
import Loading from "../components/Loading";
import Recorder from "../components/Recorder/Recorder";
import { BaseUrl, limitText } from "../utils";

import * as SignalR from "@microsoft/signalr";
import { BsMicFill, BsThreeDotsVertical } from 'react-icons/bs';
import { FaTrash } from "react-icons/fa";
import { IoMdAttach, IoMdSend } from 'react-icons/io';
import { IoTrashOutline } from 'react-icons/io5';
import { MdChevronLeft } from 'react-icons/md';
import http from '../Api';
import ListMessage from '../components/Chats/ListMessage';
import CheckUserAuth from "./../hooks/UserHook";
import '../custom.css'

//     "axios": "^0.27.2",
let controller = new AbortController();
const myInstance = new SignalR.HubConnectionBuilder()
  .configureLogging(SignalR.LogLevel.Information)
  .withUrl(BaseUrl + "/hubs/chat", {
    useDefaultCredentials: true,
    accessTokenFactory: () => "" + localStorage.getItem("token"),
  })
  .build();
export default function Home() {
  const { id } = useParams();
  const res = CheckUserAuth();
  const navigate = useNavigate();
  const [chatReports, setChatReports] = useState([]);
  const api = http();
  const [data, setData] = useState([]);
  const [current, setCurrent] = useState([]);
  const [previewImage, setPreviewImage] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [step, setStep] = useState("1");
  const [modalInput, setModalInput] = useState({});
  const [uploadList, setuploadList] = useState([]);
  const [messages, setmessages] = useState([]);
  const [input, setInput] = useState({
    roomId: id,
    name: "",
    text: "",
    messageType: 0,
    file: [],
    isNew: false
  });
  const [loaded, setLoaded] = useState(false);

  const [audio, setAudio] = useState({
    url: null,
    blob: null,
    chunks: null,
    duration: {
      h: 0,
      m: 0,
      s: 0,
    },
  });
  const handleAudioStop = (data) => {
    // console.log(data);
    setAudio({ ...data });
  };

  useEffect(() => {
    if (myInstance.state == "Disconnected") {
      myInstance
        .start()
        .then(() => {
          setLoaded(true);
          console.log("user conected signalR");
        })
        .catch((e) => {
          setLoaded(true);
          console.log(e);
        });
    }
    return () => {
      myInstance.off();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myInstance.state]);

  useEffect(() => {
    if (!res) {
      window.location = "/login";
    }
    api.GetNewChats(({ data }) => {
      setData(data);
      setLoaded(true);
    });
    api.GetCurrentChats(({ data }) => {
      setCurrent(data);
    });
    api.GetChatReports(({ data }) => {
      setChatReports(data);
    });
    return () => { };
  }, []);

  useEffect(() => {
    if (window.location.pathname.split("/")[2]) {
      api.GetMessages(({ data }) => {
        setmessages(data);
        // api.UpdateIsRead(({ data }) => { },
        //   window.location.pathname.split("/")[2]);
      }, window.location.pathname.split("/")[2]);
    }


    return () => {

    }
  }, [window.location.pathname.split("/")[2]])

  useEffect(() => {
    if (input.file.length == 0) {
      setPreviewImage(undefined);
      return;
    }
    let url = null;
    let file_urls = [];
    let files = [...input.file];
    files.map((item) => {
      url = URL.createObjectURL(item);
      file_urls.push(url);
    });
    setPreviewImage(file_urls);
    return () => URL.revokeObjectURL(url);
  }, [input.file]);

  myInstance.on("UpdateMessage", function (_id) {
    if (window.location.pathname.split("/")[2].length > 1) {
      api.GetMessages(({ data }) => {
        setmessages(data);
        // api.UpdateIsRead(({ data }) => { },
        //   window.location.pathname.split("/")[2]);
      }, window.location.pathname.split("/")[2]);
    }
  });
  myInstance.on("UpdateRooms", function () {
    api.GetNewChats(({ data }) => {
      setData(data);
      setLoaded(true);
    });
  });
  const handleAudioUpload = (file) => {
    var form = new FormData();
    form.append("roomId", input.roomId);
    form.append("messageType", input.messageType);
    var _file = new File([file], "voice.mp3");
    form.append("file", _file);

    api.SendMessage(({ data }) => {
      setInput({
        ...input,
        text: "",
        file: "",
        messageType: types.Text,
      });
    }, form);
  };
  const handleCountDown = (data) => {
    // console.log(data);
  };
  const handelClose = () => {
    setInput({ ...input, messageType: types.Text });
    handleReset();
  };

  const handleReset = () => {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0,
      },
    };
    setAudio({ ...reset });
  };
  const types = {
    Text: 0,
    Photo: 1,
    File: 2,
    Voice: 3,
  };

  function GetRoomType(type) {
    switch (type) {
      case "Ad":
        return <div className="badge wallet-badge" style={{ backgroundColor: "#a6c8ff" }}>
          آگهی ملک
        </div>;
      case "DailyRentAd":
        return <div className="badge wallet-badge" style={{ backgroundColor: "#ffb58a" }}>
          اجاره روزانه
        </div>;
      case "Product":
        return <div className="badge wallet-badge" style={{ backgroundColor: "#e2bfff" }}>
          فروشگاه
        </div>;
      case "Support":
        return <div className="badge wallet-badge" style={{ backgroundColor: "#93d490" }}>
          پشتیبانی
        </div>;
      default:
        break;
    }
  }
  return (
    <div className="row " style={{ paddingLeft: 25, paddingRight: 25 }}>
      {loaded ? (
        null
      ) : (
        <Loading />
      )}
      <div className="col-12 col-md-5">
        <div className="row">
          {data.length < 1 ? (
            <div className="col-12">
              <h6 className="text-center p-4">گفتگویی یافت نشد</h6>
            </div>
          ) : null}

          <Tabs
            defaultActiveKey="new"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="new" title={
              <p>
                در انتظار پاسخ
                <span className="badge bg-danger" style={{
                  borderRadius: 100, marginRight: 5, height: 22, width: 22, textAlign: "center",
                  justifyContent: 'center', alignContent: "center"
                }}>
                  {data.length}
                </span>
              </p>
            }>
              {data.map((item, index) => (
                <div
                  key={"newSupport-" + index}
                  onClick={() => {
                    setInput({
                      ...input,
                      name: item.name,
                      roomId: item.roomId,
                      isNew: true
                    });
                    navigate("/Chat/" + item.roomId);
                  }}
                  className="col-12 row mt-2 chat-item position-relative py-0"
                >
                  <div className="col-3 col-md-2 p-1">
                    <img
                      className="w-100 img-chat-item"
                      style={{ borderRadius: 8 }}
                      src={BaseUrl + item.image}
                      alt=""

                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src =
                          "https://amlakto.com/media/ads/defualt.png";
                        currentTarget.style = "max-height:180px";
                      }}
                    />
                  </div>
                  <div className="col-9 col-md-10 ">
                    <div className="row w-100  justify-content-between">
                      <div className="col-12 row justify-content-between align-items-center position-relative">
                        <div className="col-auto">
                          <h5 className="text-right mt-3">
                            {limitText(item?.name, 100)}
                          </h5>
                        </div>

                      </div>
                      <div className="col-12 ">
                        <h6 className="text-right text-secondary mt-2 txt-msg">
                          {GetRoomType(item.type)}
                        </h6>
                      </div>
                    </div>
                    <div className="col-12 row justify-content-between">
                      <div className="col-auto">
                        <h6 className="text-right text-secondary mt-2 txt-msg">
                          {limitText(item.lastMessage, 30)}
                        </h6>
                      </div>
                      <div className="col-auto p-0 detailOptions" style={{ bottom: 0, top: "auto", left: 7 }}>
                        {item.dateTime != "" ? <h6
                          style={{ textAlign: "left" }}
                          className=" text-secondary  "
                        >
                          {moment(item.dateTime, "yyyy/MM/DD HH:mm:ss").fromNow()}
                        </h6> : null}
                      </div>
                    </div>
                    <div className="col-auto p-0 detailOptions" style={{ top: 7 }}>
                      <Dropdown>
                        <Dropdown.Toggle variant="" id="dropdown-basic" className="">
                          <BsThreeDotsVertical size={25} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu >
                          <Dropdown.Item >
                            <div
                              className="d-flex flex-row align-items-center"
                              onClick={() => {
                                api.RemoveRoom(({ data }) => {
                                  if (data.isSuccess) {
                                    api.GetNewChats(({ data }) => {
                                      setData(data);
                                    });
                                    api.GetCurrentChats(({ data }) => {
                                      setCurrent(data);
                                    });
                                    setInput({
                                      roomId: "",
                                      name: "",
                                      text: "",
                                      messageType: 0,
                                      file: [],
                                    });
                                    navigate("/");
                                    setLoaded(true);
                                  }
                                }, item.roomId)
                              }}
                            >
                              <IoTrashOutline
                                className="my-ad-item-icon"
                                style={{ color: "#a50000" }}
                              />
                              <span
                                className="my-ad-item-text"
                                style={{ color: "#a50000" }}
                              >
                                حذف
                              </span>
                            </div>
                          </Dropdown.Item>

                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              ))}
            </Tab>
            <Tab eventKey="current" title={
              <p>
                درخواست های پذیرش شده
                <span className="badge bg-danger" style={{
                  borderRadius: 100, marginRight: 5, height: 22, width: 22, textAlign: "center",
                  justifyContent: 'center', alignContent: "center"
                }}>
                  {current.length}
                </span>
              </p>
            }>
              {current.map((item) => (
                <div
                  key={"newSupport-" + item.id}
                  onClick={() => {
                    setInput({
                      ...input,
                      name: item.name,
                      roomId: item.roomId,
                      isNew: false
                    });
                    navigate("/Chat/" + item.roomId);
                  }}
                  className="col-12 row mt-2 chat-item position-relative py-0"
                >
                  <div className="col-3 col-md-2 p-1">
                    <img
                      className="w-100 img-chat-item"
                      style={{ borderRadius: 8 }}
                      src={BaseUrl + item.image}
                      alt=""

                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src =
                          "https://amlakto.com/media/ads/defualt.png";
                        currentTarget.style = "max-height:180px";
                      }}
                    />
                  </div>
                  <div className="col-9 col-md-10 ">
                    <div className="row w-100  justify-content-between">
                      <div className="col-12 row justify-content-between align-items-center position-relative">
                        <div className="col-auto">
                          <h5 className="text-right mt-3">
                            {limitText(item.name, 100)}
                          </h5>
                        </div>

                      </div>
                      <div className="col-12 ">
                        <h6 className="text-right text-secondary mt-2 txt-msg">
                          {GetRoomType(item.type)}
                        </h6>
                      </div>
                    </div>
                    <div className="col-12 row justify-content-between">
                      <div className="col-auto">
                        <h6 className="text-right text-secondary mt-2 txt-msg">
                          {limitText(item.lastMessage, 30)}
                        </h6>
                      </div>
                      <div className="col-auto p-0 detailOptions" style={{ bottom: 0, top: "auto", left: 7 }}>
                        {item.dateTime != "" ? <h6
                          style={{ textAlign: "left" }}
                          className=" text-secondary  "
                        >
                          {moment(item.dateTime, "yyyy/MM/DD HH:mm:ss").fromNow()}
                        </h6> : null}
                      </div>
                    </div>
                    <div className="col-auto p-0 detailOptions" style={{ top: 7 }}>
                      <Dropdown>
                        <Dropdown.Toggle variant="" id="dropdown-basic" className="">
                          <BsThreeDotsVertical size={25} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu >
                          <Dropdown.Item >
                            <div
                              className="d-flex flex-row align-items-center"
                              onClick={() => {
                                api.RemoveRoom(({ data }) => {
                                  if (data.isSuccess) {
                                    api.GetNewChats(({ data }) => {
                                      setData(data);
                                    });
                                    api.GetCurrentChats(({ data }) => {
                                      setCurrent(data);
                                    });
                                    setInput({
                                      roomId: "",
                                      name: "",
                                      text: "",
                                      messageType: 0,
                                      file: [],
                                    });
                                    setLoaded(true);
                                    navigate("/");

                                  }
                                }, item.roomId)
                              }}
                            >
                              <IoTrashOutline
                                className="my-ad-item-icon"
                                style={{ color: "#a50000" }}
                              />
                              <span
                                className="my-ad-item-text"
                                style={{ color: "#a50000" }}
                              >
                                حذف
                              </span>
                            </div>
                          </Dropdown.Item>

                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              ))}
            </Tab>

          </Tabs>

        </div>
      </div>
      <div
        className="col-12 col-md-7"
        style={{ minHeight: "85vh", border: "2px solid #e2e2e2" }}
      >
        {input.isNew ?
          <div className="col-12 mt-2 mx-auto">
            <p className="text-center">
              این درخواست توسط هیچ پشتیبانی پذیرش نشده است درصورت توانایی پاسخگویی پذیرش کنید.
            </p>
            <div className="col-3 mx-auto">
              <button className="btn w-100 btn-success" onClick={() => {

                setLoaded(false);
                api.AssignChatToSupport(({ data }) => {
                  api.GetNewChats(({ data }) => {
                    setData(data);
                    setInput({ ...input, isNew: false });
                    api.GetCurrentChats(({ data }) => {
                      setCurrent(data);
                    });
                    setLoaded(true);
                  });
                }, input.roomId)
              }}>
                پذیرش این درخواست
              </button>
            </div>
          </div>
          : null}
        {data.length < 1 ? null : (
          <ListMessage
            roomId={input.roomId}
            roomName={input.name}
            onReportClick={() => setModalShow(true)}
            UploadImages={uploadList}
            CnacelUpload={() => {
              controller.abort('Operation canceled by the user.');
              setuploadList([])
              // window.location.reload();
            }}
            messages={messages}
          />
        )}
        <div className="col-12">
          {input.roomId ? (
            <div
              className="col-12  row justify-content-center align-items-center"
              style={{
                height: "15vh",
                backgroundColor: "#eee",
              }}
            >
              <div className="col-2 col-md-2 col-lg-1 p-0 d-flex justify-content-center">
                {input?.text?.length > 0 || input.file.length > 0 ? (
                  <IoMdSend
                    size={35}
                    className="btn-custom"
                    color="#777"
                    onClick={() => {
                      if (input.file.length > 0) {
                        let files = [...input.file];
                        files.map((_file, index) => {
                          let form = new FormData();
                          Object.keys(input).map((item) => {
                            if (item == "file") {
                              form.append(item, _file);
                            } else {
                              form.append(item, input[item]);
                            }
                            return null;
                          });
                          if (controller.signal.aborted) {
                            controller = new AbortController();
                          }
                          api.SendMessage(({ data }) => {
                            setuploadList([])
                            setInput({
                              ...input,
                              text: "",
                              file: [],
                              messageType: types.Text,
                            });
                          }, form, () => { }, {
                            signal: controller.signal, // <-- 2nd step
                            onUploadProgress: progressEvent => {
                              const { loaded, total } = progressEvent;
                              let percent = Math.floor((loaded * 100) / total);
                              if (percent < 100) {
                                setuploadList([{ src: previewImage[index], percent: percent }]);
                              }
                            },
                          });

                          return null;
                        });
                      } else {
                        let form = new FormData();
                        Object.keys(input).map((item) => {
                          form.append(item, input[item]);
                          return null;
                        });
                        api.SendMessage(({ data }) => {
                          setInput({
                            ...input,
                            text: "",
                            file: "",
                            messageType: types.Text,
                          });
                        }, form, () => { });
                      }
                    }}
                  />
                ) : (
                  <BsMicFill
                    size={25}
                    className="btn-custom"
                    color="#777"
                    onClick={() =>
                      setInput({ ...input, messageType: types.Voice })
                    }
                  />
                )}
              </div>
              <div className="col-8 p-0">
                {previewImage?.length > 0 &&
                  input.messageType === types.File ? (
                  <div className="row ">
                    {previewImage.map((item, index) => (
                      <div
                        className="col-6 col-md-3 col-lg-2 p-2 d-flex "
                        style={{ position: "relative" }}
                      >
                        <img
                          src={item}
                          alt=""
                          className="w-100 rounded-3 img-chat-preview "
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = require("../Assets/images/file.png");
                          }}
                        />
                        <button
                          onClick={() => {
                            let files = [...input.file];
                            files[index] = undefined;
                            files = files.filter((item) => item);
                            if (files.length == 0) {
                              setInput({ ...input, messageType: types.Text, file: [] });
                            } else {
                              setInput({
                                ...input,
                                file: [...files],
                                messageType: types.File,
                              });
                            }
                          }}
                          className="btn btn-danger  w-75 align-self-center"
                          style={{
                            position: "absolute",
                            zIndex: 999,
                            bottom: 12,
                            right: "12%",
                          }}
                        >
                          <FaTrash />
                        </button>

                      </div>
                    ))}
                  </div>
                ) : null}
                {input.messageType === types.Text ? (
                  <input
                    type="text"
                    placeholder="متن پیام ..."
                    className="form-control w-100"
                    value={input.text}
                    multiple
                    onChange={(e) =>
                      setInput({
                        ...input,
                        text: e.target.value,
                        messageType: types.Text,
                      })
                    }
                    name=""
                  />
                ) : null}
              </div>
              <div className="col-2 col-md-2 col-lg-1 p-0 d-flex justify-content-center">
                <label htmlFor="chatFileInput">
                  <IoMdAttach
                    className="btn-custom"
                    size={30}
                    color="#777"
                  />
                  <input
                    type="file"
                    id="chatFileInput"
                    className="d-none"
                    multiple
                    onChange={(e) => {
                      if (e.target.files.length > 4) {
                        toast.error("حد اکثر انتخاب فایل ۴ عدد می باشد")
                      } else {
                        setInput({
                          ...input,
                          file: e.target.files,
                          messageType: types.File,
                        });
                      }
                    }}

                  />
                </label>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            گزارش گفتگو
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {step == "1" ? (
            <div className="row">
              <div className="col-12">
                <h4>دلیل گزارش </h4>
                <h6 className="mt-2">
                  - نزدیک‌ترین دلیل را برای تخلف این کاربر انتخاب کنید.
                </h6>
                <h6 className="mb-2">
                  - برای حفظ حریم خصوصی شما، گزارش محرمانه ارسال می‌شود و نزد
                  املاک تو محفوظ می‌ماند.
                </h6>
              </div>

              {chatReports.map((item) => (
                <div
                  className="col-12 p-2"
                  style={{ borderBottom: "1px solid #e2e2e2" }}
                  onClick={() => {
                    setModalInput(item);
                    setStep("2");
                  }}
                >
                  <div className="row justify-content-center align-items-center">
                    <div className="col-10">
                      <h6 className="mt-2">{item.title}</h6>
                    </div>
                    <div className="col-2">
                      <MdChevronLeft size={25} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <h4>{modalInput.title} </h4>
                <h6 className="mt-2">
                  املاک تو در صورت مشاهدهٔ موارد زیر، کاربر را مسدود می‌کند:
                </h6>

                <h6 className="mt-2">{modalInput.description}</h6>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => (step == "1" ? setModalShow(false) : setStep("1"))}
            variant="danger"
          >
            بازگشت
          </Button>
          {step == "2" ? (
            <Button
              onClick={() => {
                api.ReportChat(({ data }) => { }, {
                  reportId: modalInput.id,
                  roomId: input.roomId,
                });
                setModalShow(false);
                setStep("1");
              }}
              variant="primary"
            >
              ثبت گزارش
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={input.messageType == types.Voice ? true : false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            ارسال صدا
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <Recorder
              record={true}
              title={"ارسال صدا"}
              audioURL={audio.url}
              showUIAudio
              handleAudioStop={(data) => handleAudioStop(data)}
              handleAudioUpload={(data) => handleAudioUpload(data)}
              handleCountDown={(data) => handleCountDown(data)}
              handelClose={() => handelClose()}
              handleReset={() => handleReset()}
              mimeTypeToUseWhenRecording={`audio/webm`} // For specific mimetype.
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setInput({ ...input, messageType: types.Text })}
            variant="danger"
          >
            بازگشت
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}